import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import type { APIResponse, ContactNote } from "@/lib/types";
import { baseContactRoute } from "./contact";

// #region --------------- Contact Note API requests -----------------
export type CreateContactNoteInput = Pick<
  ContactNote,
  "contactId" | "draft" | "message"
>;

export function createContactNoteV1(data: CreateContactNoteInput) {
  const { contactId, draft, message } = data;

  return authenticatedFastApiAxiosInstance
    .post<APIResponse<ContactNote>>(`${baseContactRoute}/notes`, {
      contactId,
      draft,
      message,
    })
    .then((res) => res.data);
}

export function updateContactNoteV1(
  data: Pick<ContactNote, "contactId" | "id" | "dateModified"> &
    Partial<ContactNote>,
) {
  return authenticatedFastApiAxiosInstance
    .patch<APIResponse<ContactNote>>(`${baseContactRoute}/notes`, data)
    .then((res) => res.data);
}

export function deleteContactNoteV1({ id }: { contactId: string; id: string }) {
  return authenticatedFastApiAxiosInstance
    .delete<APIResponse<ContactNote>>(`${baseContactRoute}/notes/${id}`)
    .then((res) => res.data);
}
